import React from 'react';

import { Flex, Text } from '@chakra-ui/react';
import dayjs from 'dayjs';

import { WeekDays } from 'components';
import { FrequencyTypes } from 'enums/types';

export function Frequency({ value, original, variant }) {
  if (value === FrequencyTypes.Monthly) {
    return (
      <Flex>
        <Text variant={variant}>
          {`${value} ${dayjs(original.nextExecution).daysInMonth()}`}
        </Text>
      </Flex>
    );
  }
  if (value === FrequencyTypes.Weekly) {
    return <WeekDays days={original.weekDays} />;
  }
  return (
    <Flex>
      <Text variant={variant}>
        {value}
      </Text>
    </Flex>
  );
}
